var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResultsSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3125 65.4375L56.4375 48.5625C60.2344 42.9375 62.2031 35.9062 61.2188 28.3125C59.3906 15.375 48.8438 4.96875 36.0469 3.28125C16.9219 0.890625 0.75 17.0625 3.14062 36.1875C4.82812 48.9844 15.2344 59.5312 28.1719 61.3594C35.7656 62.3438 42.7969 60.375 48.5625 56.5781L65.2969 73.4531C67.5469 75.5625 71.0625 75.5625 73.3125 73.4531C75.4219 71.2031 75.4219 67.6875 73.3125 65.4375ZM14.1094 32.25C14.1094 22.4062 22.125 14.25 32.1094 14.25C41.9531 14.25 50.1094 22.4062 50.1094 32.25C50.1094 42.2344 41.9531 50.25 32.1094 50.25C22.125 50.25 14.1094 42.2344 14.1094 32.25Z",
    fill: "url(#paint0_linear_6006_21265)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6006_21265",
    x1: 39.3429,
    y1: -21.5,
    x2: 39.3429,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.100912,
    stopColor: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsSearchIcon);
export default __webpack_public_path__ + "static/media/no-results-search-icon.fa0066039869e126f4aa07e2c30c0763.svg";
export { ForwardRef as ReactComponent };